/**
 * 入口文件
 */
import React from "react";
import ReactDOM from "react-dom";
import "./static/css/css-reset.less";
import App from "./App.jsx";
import "lib-flexible";
import storage from "@src/utils/storage";
import userInfo from "@src/utils/userInfo";
import { getCookie, setCookie } from "@src/utils/cookie";
import { verifySafeCode, getVerifyCode } from "@src/api/safeCodeVerify";
import "./index.less";

const VERIFY_PAGE = "https://websafeverify.beijingfundtown.com";
const COOKIE_DOMAIN = ".beijingfundtown.com";

/** 地址包含 local（如 localhost）则不做人机验证跳转，方便本地运行 */
function isLocalEnv() {
  return window.location.hostname.toLowerCase().indexOf("local") !== -1;
}

function redirectToHumanVerify() {
  const redirect = encodeURIComponent(window.location.href);
  window.location.href = `${VERIFY_PAGE}?redirect=${redirect}`;
}

/** 回跳时若 URL 带 safe_code，写入当前域 cookie 并去掉参数；防止跨域/端口导致读不到验证页写的 cookie 而来回跳 */
function saveSafeCodeFromQuery() {
  try {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("safe_code");
    if (code) {
      const hostname = window.location.hostname.toLowerCase();
      const sameRoot = hostname === "beijingfundtown.com" || hostname.endsWith(".beijingfundtown.com");
      setCookie("safe_code", code, 24 * 60 * 60, sameRoot ? COOKIE_DOMAIN : undefined);
      const url = new URL(window.location.href);
      url.searchParams.delete("safe_code");
      window.history.replaceState({}, "", url.pathname + url.search + url.hash);
    }
  } catch (e) {}
}

// 读取本地 user 信息
const user = storage.getUser();
userInfo.user = user;

const rootEl = document.getElementById("root");

async function bootstrap() {
  if (isLocalEnv()) {
    ReactDOM.render(<App />, rootEl);
    return;
  }

  saveSafeCodeFromQuery();
  const safeCode = getCookie("safe_code");

  if (!safeCode) {
    redirectToHumanVerify();
    return;
  }

  try {
    const res = await verifySafeCode(safeCode);
    const code = getVerifyCode(res);
    const passed = code === 0 || code === 200 || code === "0" || code === "200";
    const requestFailed = code === -1 || code === "-1";
    if (passed || requestFailed) {
      ReactDOM.render(<App />, rootEl);
      return;
    }
    redirectToHumanVerify();
  } catch (e) {
    ReactDOM.render(<App />, rootEl);
  }
}

bootstrap();
